"use client";

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AdminShell } from "@/components/AdminShell";
import { apiClient } from "@/lib/api-client";
import { useQueryParam } from "@/lib/use-query-param";
import type { Conversation } from "@/types/conversation";

export default function InboxPage() {
  const projectId = useQueryParam("projectId");
  const [conversations, setConversations] = useState<Conversation[]>([]);

  useEffect(() => {
    if (!projectId) return;
    apiClient<{ conversations: Conversation[] }>(`/api/projects/${projectId}/conversations`)
      .then((data) => setConversations(data.conversations))
      .catch(() => setConversations([]));
  }, [projectId]);

  return (
    <AdminShell>
      <h1 className="text-2xl font-semibold text-ink">Conversation Inbox</h1>
      <div className="mt-6 grid gap-3">
        {conversations.map((conversation) => (
          <Link key={conversation.id} className="rounded-card border border-line bg-white p-4 hover:border-brand" to={`/dashboard/thread?projectId=${projectId}&conversationId=${conversation.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <h2 className="font-semibold text-ink">{conversation.contact_name || conversation.normalized_phone}</h2>
                <p className="mt-1 text-sm text-muted">{conversation.normalized_phone} · {conversation.status}</p>
              </div>
              <span className="rounded bg-surface px-2 py-1 text-xs text-muted">{conversation.last_message_at ? "updated" : "new"}</span>
            </div>
            <p className="mt-3 text-sm text-muted">{conversation.last_message || "Belum ada pesan."}</p>
          </Link>
        ))}
        {conversations.length === 0 && <div className="rounded-card border border-line bg-white p-6 text-sm text-muted">Belum ada conversation masuk.</div>}
      </div>
    </AdminShell>
  );
}
